import { Divider, Grid } from '@mui/material';
import React from 'react';
import { FactboxBase } from '../common/utils';
import { TwoColumnFactboxProps } from './two-column-factbox-types';
import { TwoColumnSection } from './two-column-utils';

export const TwoColumnFactbox = (props: TwoColumnFactboxProps) => {
  const { options } = props;
  const { sections } = options;
  const { leftSection, rightSection } = sections;
  return (
    <FactboxBase
      title={options.title}
      subtitle={options.subtitle}
      footer={options.footer}
      fontSize={options.fontSize}
    >
      <Grid
        item
        container
        direction="row"
        sx={{ flexGrow: 1, height: '100%' }}
        alignItems="center"
        wrap="nowrap"
      >
        <Grid
          item
          sx={{ flexGrow: 1, flexBasis: 0, height: '100%', minWidth: 0 }}
        >
          <TwoColumnSection section={leftSection} />
        </Grid>
        <Divider
          orientation="vertical"
          sx={{
            backgroundColor: '#ffffff',
            height: '80%',
            margin: '0 1rem',
          }}
        />
        <Grid
          item
          sx={{ flexGrow: 1, flexBasis: 0, height: '100%', minWidth: 0 }}
        >
          <TwoColumnSection section={rightSection} />
        </Grid>
      </Grid>
    </FactboxBase>
  );
};
